import * as React from "react"
const FilePDFIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={ 32 }
    height={ 40 }
    fill="none"
    { ...props }
  >
    <path
      stroke="#EE4F5C"
      strokeWidth={ 2 }
      d="m1.595 10.357 8.898-8.78A2 2 0 0 1 11.898 1H28a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V11.78a2 2 0 0 1 .595-1.423Z"
    />
    <path stroke="#EE4F5C" strokeWidth={ 2 } d="M11 2v9a1 1 0 0 1-1 1H2" />
    <path
      fill="#EE4F5C"
      fillRule="evenodd"
      d="M15.488 16h.024a2.081 2.081 0 0 1 1.737.969c.697 1.078.58 2.916-.032 5.216.087.098.178.194.272.287.467.464.952.882 1.444 1.249 1.697-.251 3.148-.138 4.047.445.644.416 1.02 1.076 1.02 1.823 0 .824-.446 1.52-1.195 1.828-1.107.456-2.704-.039-4.47-1.14a10.59 10.59 0 0 0-1.778.589c-.596.261-1.16.52-1.685.772C13.548 30.549 12.156 32 10.357 32a3.07 3.07 0 0 1-.845-.12c-.959-.274-1.456-.92-1.508-1.666-.091-1.36 1.5-2.634 4.792-4.274.214-.444.396-.853.718-1.598l.186-.428c.15-.344.305-.756.453-1.203-1.069-1.786-1.371-3.794-.79-5.188.387-.936 1.174-1.523 2.125-1.523Zm-2.27 11.607-.467.73c-.936 1.463-1.85 2.198-2.777 1.93l-.053-.016-.053-.02-.255-.094.144-.231c.245-.39 1.162-1.035 2.55-1.802l.15-.083.76-.414Zm2.821-4.218-.254-.27-.118.351-.099.282c-.101.282-.21.56-.328.835l-.18.418-.076.175c-.099.23-.192.442-.286.653l-.239.536.535-.244.082-.037c.22-.1.454-.204.804-.358.498-.217 1.044-.41 1.604-.564l.424-.117-.346-.272-.262-.212c-.347-.286-.68-.587-1-.904a12.548 12.548 0 0 1-.26-.272Zm6.024 2.184c.176.114.242.236.25.42l.002.064-.002.108-.086.065c-.298.226-1.11.028-2.099-.463l-.115-.058-.73-.374.82-.046c.888-.049 1.594.045 1.96.284Zm-6.229-7.696a.394.394 0 0 0-.344-.2h-.01c-.252.005-.437.184-.563.486-.3.72-.173 1.947.381 3.122l.274.58.144-.625c.372-1.616.449-2.852.118-3.363Z"
      clipRule="evenodd"
    />
  </svg>
)
export default FilePDFIcon
